import { useEffect, useRef } from 'react';
import { Renderer, Stave, Barline } from 'vexflow';

export const TrackClef = ({ clef }: { clef: string }) => {
	const canvasRef = useRef<HTMLCanvasElement>(null);

	useEffect(() => {
		if (canvasRef.current) {
			const canvas = canvasRef.current;
			if (!canvas || !canvas.parentElement) return;

			const canvasWidth = 52;
			const canvasHeight = canvas.parentElement.clientHeight;

			canvas.width = canvasWidth;
			canvas.height = canvasHeight;

			let processedClef = clef.toLowerCase();
			let useGrandStaff = processedClef === 'grandstaff';
			if (useGrandStaff) processedClef = 'treble'; // Default to treble clef for grand staff and use a secondary bass staff
			let staveY = useGrandStaff ? 16 : 46; // Y position for the first stave

			const renderer = new Renderer(canvas, Renderer.Backends.CANVAS);
			const context = renderer.getContext();

			// Create the stave (staff) for drawing
			const stave = new Stave(0, staveY, canvas.width); // x, y, width
			stave
				.addClef(processedClef)
				.addTimeSignature('4/4', 2)
				.setBegBarType(Barline.type.DOUBLE) // Use VF.Barline.type.DOUBLE for a double barline
				.setContext(context);

			stave.draw();

			if (useGrandStaff) {
				const bassStave = new Stave(0, staveY + 60, canvas.width);
				bassStave
					.addClef('bass')
					.addTimeSignature('4/4', 2)
					.setBegBarType(Barline.type.DOUBLE) // Use VF.Barline.type.DOUBLE for the bass stave
					.setContext(context);

				bassStave.draw();
			}
		}
	}, [clef]);

	return (
		<canvas ref={canvasRef} />
	);
};
